import Axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { deleteCookie, getCookie } from './cookiesHandler'

Vue.use(Vuex)

function valideData ( data ) {
  return data != null &&
    data != undefined &&
    data != ""
}

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "bce072b8c4399e048f58a4b600adac37"
    })
  ],
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    user: {},
    new_course: {},
    isLogged: false, //!!getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00'),
    cart: [],
    cardHash: undefined,
    loadingState: false,
    leasson: undefined,
    dragging: undefined,
    courseShowtime: undefined,
    leassonProgress: 0,
    registrationComplete: false,
    addressComplete: false
  },
  mutations: {
    LOGIN_USER (state) {
      state.isLogged = true
    },

    LOGOUT_USER (state) {
      state.isLogged = false;
      state.user = {};
      deleteCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00');
    },

    SET_CURRENT_USER (state, data) {
      state.user = {
        id: data.id,
        name: data.name,
        type: data.type,
        picture: data.picture,
        profession: data.profession,
        social_avatar: data.social_avatar,
        document: data.document,
        phone: data.phone,
        address: data.address,
        number: data.number,
        district: data.district,
        state: data.state,
        city: data.city,
        country: data.country,
        zip_code: data.zip_code,
      }
    },

    SET_INFO (state, data) {
      state.new_course.info = data
    },

    SET_REQUIREMENT (state, data) {
      state.new_course.requirements = data
    },

    SET_GRADE (state, data) {
      if ( !state.new_course.grade )
        state.new_course.grade = []
      state.new_course.grade = [ ...state.new_course.grade, data ]
    },

    SET_TAGS (state, data) {
      state.new_course.tags = data
    },

    SET_MEDIA (state, data) {
      state.new_course[data.value] = data
    },

    SET_FINISH (state, data) {
      state.new_course.finish = data
    },

    SET_MEDIAS_COURSE (state, data) {
      state.new_course.medias = {
        cover: data.cover,
        thumbnail: data.thumbnail,
        video: data.video
      }
    },

    CLEAN_COURSE (state) {
      state.new_course = {}
    },

    ADD_TO_CART (state, obj) {
      let course = state.cart.filter( item => {
        return item.id === obj.id
      })

      if ( course.length === 0 ) state.cart.push( obj )
    },

    CLEAN_CART ( state ) {
      state.cart = []
    },

    REMOVE_FROM_CART (state, obj) {
      let courses = state.cart.filter( item => {
        return item.id != obj.id
      })

      state.cart = courses
    },

    CHANGE_FORM_OF_PAYMENT_ITEM ( state, obj ) {
      let item = state.cart.findIndex( item => {
        return item.id == obj.id
      })

      Vue.set(state.cart[ item ], 'payment_form', obj.value)
      Vue.set(state.cart[ item ], 'max_quotas', obj.max_quotas)
    },

    CHANGE_QUOTAS_CART_ITEM ( state, obj ) {
      let item = state.cart.findIndex( item => {
        return item.id == obj.id
      })

      Vue.set(state.cart[ item ], 'quotas', obj.value)
    },

    SET_CARD_HASH ( state, obj ) {
      state.cardHash = obj
    },

    TOGGLE_LOADING ( state, value ) {
      state.loadingState = value
    },

    DEFINE_LEASSON ( state, value ) {
      state.leasson = value
    },

    SET_DRAGGING ( state, value ) {
      // Vue.set(state, 'currentLeasson', value)
      state.dragging = value
    },

    SET_SHOWTIME ( state, value ) {
      // Vue.set(state, 'currentLeasson', value)
      state.courseShowtime = value
    },

    UPDATE_PROGRESS (state, value) {
      state.leassonProgress = {
        id: value.id,
        course: value.course,
        progress: value.progress,
        user: state.user.id
      }
    },

    UPDATE_CLASSE ( state, value ) {
      let course = state.courseShowtime
      let classes = course.items
      let updated = false

      classes.every(element => {
        element.leassons.every( leason => {
          if(leason.id == value.id) {
            state.leassonProgress = {
              id: value.id,
              course: value.course,
              progress: value.progress,
            }
            leason.progress = value.progress
            updated = true
          }
          return updated
        })
        return updated
      });
      course.items = [ ...classes ]
      state.courseShowtime = { ...course }
    },

    NEXT_CLASS ( state ) {
      let course = state.courseShowtime
      let classes = course.items
      let updated = false

      classes.every(element => {
        element.leassons.every( leason => {
          if(leason.progress != 100 && !updated) {
            state.leasson = leason
            updated = true
          }
          return !updated
        })
        return updated
      });
    }
  },
  actions: {
    login ({ commit }) {
      commit('LOGIN_USER')
    },

    logout ({ commit }) {
      commit('LOGOUT_USER')
    },

    setInfo ({ commit }, data) {
      commit('SET_INFO', data)
    },

    setRequirement ({ commit }, data) {
      commit('SET_REQUIREMENT', data)
    },

    setGrade ({ commit }, data) {
      commit('SET_GRADE', data)
    },

    setTags ({ commit }, data) {
      commit('SET_TAGS', data)
    },

    setFinish ({ commit }, data) {
      commit('SET_FINISH', data)
    },

    removeModule ({ commit }, data) {
      commit('REMOVE_MODULE', data)
    },

    saveClass ({ commit }, data) {
      commit('SAVE_CLASS', data)
    },

    addClass ({ commit }, data) {
      commit('ADD_CLASS', data)
    },

    setMedias ({ commit }, data) {
      commit('SET_MEDIAS_COURSE', data)
    },

    cleanCourse ({ commit }) {
      commit('CLEAN_COURSE')
    },

    addItemToCart ({ commit }, obj) {
      commit('ADD_TO_CART', obj)
    },

    changeItemCartFormOfPayment ({ commit }, obj) {
      commit('CHANGE_FORM_OF_PAYMENT_ITEM', obj)
    },

    changeItemCartQuotas ({ commit }, obj) {
      commit('CHANGE_QUOTAS_CART_ITEM', obj)
    },

    cleanCart ({ commit }) {
      commit('CLEAN_CART')
    },

    setHash({commit}, obj) {
      commit('SET_CARD_HASH', obj)
    },

    cleanHash({commit}) {
      commit('SET_CARD_HASH', {})
    },

    removeItemFromCart ({ commit }, obj) {
      commit('REMOVE_FROM_CART', obj)
    },

    setLeason ( { commit }, value ) {
      commit('DEFINE_LEASSON', value )
    },

    setDragging ( { commit }, value ) {
      commit('SET_DRAGGING', value )
    },

    setShowtime ( { commit }, value ) {
      commit('SET_SHOWTIME', value )
    },

    updateLeason ({commit}, value) {
      commit('UPDATE_CLASSE', value)
    },

    updateProgress({commit}, value) {
      commit('UPDATE_PROGRESS', value)
    },

    nextClass({commit}) {
      commit('NEXT_CLASS')
    }
  },
  getters: {
    getLoggedState: async state => {
      var data;

      await Axios.post('/auth/me')
        .then(res => {
          data = res.data;
          state.isLogged = true
          state.user = res.data
        })
        .catch(() => {
          state.isLogged = false,
          state.user = {}
        });
      return state.isLogged;
    },
    getCurrentUser: state => state.user,
    getNewCourse: state => state.new_course,

    getNewCourseInfo: state =>  {
      if ( state.new_course.info )
        return state.new_course.info
      else
        return {}
    },

    getNewCourseRequirement: state =>  {
      if ( state.new_course.requirements )
        return state.new_course.requirements
      else
        return {}
    },

    getNewCourseMedias: state =>  {
      if ( state.new_course.medias )
        return state.new_course.medias
      else
        return {}
    },

    getNewCourseTags: state =>  {
      if ( state.new_course.tags )
        return state.new_course.tags
      else
        return []
    },

    getNewCourseGrade: state => {
      if ( state.new_course.grade )
        return state.new_course.grade
      else
        return []
    },

    getCartCount: state => {
      return state.cart.length
    },

    getCart: state => {
      return state.cart
    },

    getCardHash: state => state.cardHash,

    statusComplete: state => {
      return valideData( state.user.document ) &&
        valideData( state.user.phone ) &&
        valideData( state.user.address ) &&
        valideData( state.user.number ) &&
        valideData( state.user.district ) &&
        valideData( state.user.state ) &&
        valideData( state.user.city ) &&
        valideData( state.user.country ) &&
        valideData( state.user.zip_code ) &&
        valideData( state.user.profession )
    },

    addressComplete: state => valideData( state.user.address ) &&
      valideData( state.user.number ) &&
      valideData( state.user.district ) &&
      valideData( state.user.state ) &&
      valideData( state.user.city ) &&
      valideData( state.user.zip_code ),

    authMarketPlace: state => {
      return valideData( state.user.mp_date ) && state.user.type === 'TCH';
    },

    emailVerified: state => {
      return true //valideData( state.user.email_verified_at )
    },

    isLoadding: state => {
      return state.loadingState
    },

    currentLeasson: state => state.leasson,

    getCurrentLeasonIds: state => {
      if ( !state.leasson ) return {}
      return {
        leason: state.leasson.id,
        course: state.leasson.course
      }
    },

    getShowtime: state => state.courseShowtime,
    getShowtimeCourse: state => state.courseShowtime.course,
    getShowtimeCoursePartners: state => state.courseShowtime.partners,
    getProgress: state => state.leassonProgress,

    getDragging: state => state.dragging
  }
})
